export default "__VITE_ASSET__Dro1TQn8__"